import {useContext} from "react";
import QRCodeStyleViewContext from "../../../QRCodeStyleViewContext";
import SubView from "../../SubView";
import {ColorInput, Stack} from "@mantine/core";
import CornersDotStyle from "../../../../../../../../api/qr-code/style/CornersDotStyle";
import HorizontalListView from "../../../_utils/horizontal-list-view/HorizontalListView";
import HorizontalListViewItem from "../../../_utils/horizontal-list-view/item/HorizontalListViewItem";
import CornersSquareStyle from "../../../../../../../../api/qr-code/style/CornersSquareStyle";

function MoreCornersView() {
    const {payload, setPayload} = useContext(QRCodeStyleViewContext);

    /**
     * On dot style icon is clicked
     * @author Kacper Faber
     * @since 0.1.9
     */
    const onDotStyleClick = (cornersDotStyle: CornersDotStyle) => {
        if (!payload) {
            return;
        }

        setPayload({...payload, cornersDotStyle});
    }

    /**
     * On square icon is clicked.
     * @author Kacper Faber
     * @since 0.1.9
     */
    const onSquareStyleClick = (cornersSquareStyle: CornersSquareStyle) => {
        if (!payload) {
            return;
        }

        setPayload({...payload, cornersSquareStyle});
    }

    /**
     * On dot color change
     * @author Kacper Faber
     * @since 0.1.9
     */
    const onDotColorChange = (color: string) => {
        if (!payload) {
            return;
        }
        setPayload({...payload, cornersDotColor: color})
    };

     const onSquareColorChange = (color: string) => {
        if (!payload) {
            return;
        }
        setPayload({...payload, cornersSquareColor: color})
    };

    return (
        <SubView viewBack="index">
            <Stack gap='xl'>
                <HorizontalListView label="Styl kropki">
                    <HorizontalListViewItem
                        children={ <div style={{ borderRadius: '15px', width: '10px', height: '10px', background: 'black' }}/> }
                        onClick={() => onDotStyleClick('dot')}
                        active={payload?.cornersDotStyle == 'dot'}
                    />

                     <HorizontalListViewItem
                        children={ <div style={{ width: '10px', height: '10px', background: 'black' }}/> }
                        onClick={() => onDotStyleClick('square')}
                        active={payload?.cornersDotStyle == 'square'}
                    />

                     <HorizontalListViewItem
                        children={ <div style={{ width: '10px', height: '10px', background: 'black' }}/> }
                        onClick={() => onDotStyleClick('none')}
                        active={payload?.cornersDotStyle == 'none'}
                    />
                </HorizontalListView>

                <ColorInput
                    onChangeEnd={onDotColorChange}
                    value={payload?.cornersDotColor ?? ''}
                />

                <HorizontalListView label="Styl narożnika">
                     <HorizontalListViewItem
                        children={ <div style={{ borderRadius: '15px', width: '10px', height: '10px', border: '1px dotted black' }}/> }
                        onClick={() => onSquareStyleClick('none')}
                        active={payload?.cornersSquareStyle == 'none'}
                    />

                    <HorizontalListViewItem
                        children={ <div style={{ borderRadius: '15px', width: '10px', height: '10px', background: 'black' }}/> }
                        onClick={() => onSquareStyleClick('dot')}
                        active={payload?.cornersSquareStyle == 'dot'}
                    />

                     <HorizontalListViewItem
                        children={ <div style={{ width: '10px', height: '10px', background: 'black' }}/> }
                        onClick={() => onSquareStyleClick('square')}
                        active={payload?.cornersSquareStyle == 'square'}
                    />

                    <HorizontalListViewItem
                        children={ <div style={{ borderRadius: '15px', width: '10px', height: '10px', background: 'black' }}/> }
                        onClick={() => onSquareStyleClick('extra_rounded')}
                        active={payload?.cornersSquareStyle == 'extra_rounded'}
                    />
                </HorizontalListView>

                <ColorInput
                    onChangeEnd={onSquareColorChange}
                    value={payload?.cornersSquareColor ?? ''}
                />
            </Stack>
        </SubView>
    );
}

export default MoreCornersView;